import "core-js/modules/es.object.assign.js";
import { h } from "vue";
//@ts-ignore
import { getDefaultSvgPropsValues } from "@vueEntry/SvgIcons/DefaultValues";
export var PrestigeIcon = function PrestigeIcon(props, _ref) {
  var attrs = _ref.attrs;
  var _a, _b, _c, _d, _e;
  props = Object.assign(Object.assign({}, getDefaultSvgPropsValues()), props);
  var _props = props,
    width = _props.width,
    height = _props.height;
  return h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.97 16.303",
    width: "".concat(width),
    height: "".concat(height),
    "class": (_a = props["class"]) !== null && _a !== void 0 ? _a : "",
    "aria-hidden": (_b = attrs["aria-hidden"]) !== null && _b !== void 0 ? _b : "true"
  }, h("g", {
    fill: (_c = attrs["fill-color"]) !== null && _c !== void 0 ? _c : "none",
    stroke: (_d = attrs["stroke-color"]) !== null && _d !== void 0 ? _d : "#222",
    "stroke-width": "".concat((_e = attrs["stroke-width"]) !== null && _e !== void 0 ? _e : "1.3")
  }, [h("path", {
    d: "m.842 4.74 7.813 10.745a.407.407 0 0 0 .659 0l7.815-10.748a.679.679 0 0 0-.107-.915L13.588.879a.951.951\n             0 0 0-.619-.229H5.037a.95.95 0 0 0-.615.226L.951 3.823a.679.679 0 0 0-.109.917Z"
  }), h("path", {
    d: "M7.736.65 5.153 3.83a.91.91 0 0 0-.148.885l3.976 10.91a.01.01 0 0 0\n             .018 0l4.086-11.028a.91.91 0 0 0-.138-.879L10.536.65"
  }), h("path", {
    d: "M.773 4.309h16.545"
  })]));
};